module.exports = {
  PENDING: 'pending',
  AUTHORIZED: 'authorized',
  UNAUTHORIZED: 'unauthorized',
  CAPTURED: 'captured',
  SKIPPED: 'skipped',
  ON_SITE: 'on-site',
  RELEASED: 'released', // = cancelled or refunded
};
